<template>
	<Row class="page-container-row">
		<Col :span="24" :offset="0" :xxl="{ span: 12, offset: 6 }">
			<PageContainer>
				<Card>
					<Spin :spinning="isLoading">
						<Result
							v-if="status === 'ok'"
							status="success"
							:title="$t('account.linkedEmails.verifySuccessTitle')"
							:sub-title="email"
						>
							<template #extra>
								<Button type="primary" @click="goAccount">
									{{ $t('account.linkedEmails.verifyGoAccount') }}
								</Button>
							</template>
						</Result>
						<Result
							v-else-if="status === 'error'"
							status="error"
							:title="$t('account.linkedEmails.verifyErrorTitle')"
							:sub-title="errorText"
						/>
					</Spin>
				</Card>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Row, Col, Card, Spin, Result, Button } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';

import ApiAlertsEmail from '@/api/ApiAlertsEmail';

import PageContainer from '@/components/common/PageContainer';


export default {
	components: {
		Row, Col, Card, Spin, Result, Button, PageContainer,
	},
	setup() {
		const { t } = useI18n();
		const route = useRoute();
		const router = useRouter();
		const isLoading = ref(true);
		const status = ref('');
		const email = ref('');
		const errorText = ref('');

		onMounted(() => {
			const code = route.params.code;
			ApiAlertsEmail.alertsEmailAccountsVerify(code, response => {
				isLoading.value = false;
				if (response.status === 'ok') {
					status.value = 'ok';
					email.value = response.email || '';
				} else {
					status.value = 'error';
					errorText.value = t('account.linkedEmails.verifyErrorText');
				}
			}, () => {
				isLoading.value = false;
				status.value = 'error';
				errorText.value = t('account.linkedEmails.verifyErrorText');
			});
		});

		const goAccount = () => {
			router.push({ name: 'account' });
		};

		return {
			isLoading,
			status,
			email,
			errorText,
			goAccount,
		};
	},
};
</script>
